// extracted by mini-css-extract-plugin
export default {"container":"NotifyOnLaunch_container__4ndVZ","formBox":"NotifyOnLaunch_formBox__NWhN0","thankYouMessage":"NotifyOnLaunch_thankYouMessage__BvUxw"};